import { useEffect, type ReactNode } from 'react'
import { useNavigate } from '@axilon-apps/libs-ui-components'
import { useIdentityPaths } from '@axilon-apps/domains-identity/shared/core'
import {
  authenticationLogout,
  useDispatch,
  useSelector,
  hasTokenSelector,
  hasCurrentUserIncompleteOnboardingSelector,
  isCurrentUserQueryLoadedSelector,
  isCurrentUserQueryRejectedSelector
} from '@axilon-apps/domains-identity/state'

interface Props {
  children: ReactNode
}

const AuthenticationGuard = ({ children }: Props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const paths = useIdentityPaths()
  const hasToken = useSelector(hasTokenSelector)
  const isCurrentUserQueryLoaded = useSelector(isCurrentUserQueryLoadedSelector)
  const isCurrentUserQueryRejected = useSelector(isCurrentUserQueryRejectedSelector)
  const hasCurrentUserIncompleteOnboarding = useSelector(hasCurrentUserIncompleteOnboardingSelector)

  useEffect(() => {
    if (!hasToken) {
      navigate(paths.authentication.login, { replace: true })
    } else if (isCurrentUserQueryRejected) {
      dispatch(authenticationLogout({ skipSessionDelete: true }))
      navigate(paths.authentication.login, { replace: true })
    } else if (isCurrentUserQueryLoaded && hasCurrentUserIncompleteOnboarding) {
      navigate(paths.onboarding.changeInitialPassword, { replace: true })
    }
  }, [
    dispatch,
    hasToken,
    hasCurrentUserIncompleteOnboarding,
    isCurrentUserQueryLoaded,
    isCurrentUserQueryRejected,
    navigate,
    paths
  ])

  if (!hasToken) {
    return null
  } else if (isCurrentUserQueryRejected) {
    return null
  } else if (!isCurrentUserQueryLoaded) {
    return <>Loading...</>
  } else if (isCurrentUserQueryLoaded && hasCurrentUserIncompleteOnboarding) {
    return null
  }

  return children
}

export default AuthenticationGuard
